<template>
  <div class="signup">
    <header class="signup-header">
      <a href="/">
        <img alt="Rosporc logo" src="@/assets/images/front_logo_inverted.svg">
      </a>
    </header>
    <h1 class="container">Registro al Mercado de Porcinos</h1>
    <RegistrationForm/>
  </div>
</template>

<script>
import RegistrationForm from '@/components/RegistrationForm.vue'
import axios from 'axios'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

export default {
  name: 'signUp',
  components: {
    RegistrationForm
  }
}
</script>
